<template>
    <div class="wrapper">
        <template v-for="(slice, index) in slices">
            <FeaturedCardBanner 
                v-if="slice.slice_type === 'featured_card_banner'" 
                :key="index" 
                :slice="slice"
                :is-first="index === 0"
            />
            <component
                :is="sliceType(slice.slice_type)"
                v-else
                :key="index"
                :slice="slice"
                :document="addDocumentToSlice(slice)"
                :is-first="index === 0"
            />
        </template>
    </div>
</template>

<script>
import Vue from 'vue';
const ComponentContext = require.context('@/components/slices', true, /\.vue$/i, 'eager');
ComponentContext.keys().forEach((componentFilePath) => {
    const componentName = componentFilePath.split('/').pop().split('.')[0];
    Vue.component(componentName, () => ComponentContext(componentFilePath));
});
export default {
    props: {
        slices: {
            type: Array,
            required: true,
            default: () => {}
        },
        document: {
            type: Object,
            required: true
        }
    },
    methods: {
        sliceType(type) {
            if (type === 'table') {
                return 'ContentTable';
            }
            if (type.includes('_')) {
                let split = type.split('_');
                for (let i = 0; i < split.length; i++) {
                    split[i] = split[i].charAt(0).toUpperCase() + split[i].slice(1);
                }
                return split.join('');
            }

            return type;
        },
        addDocumentToSlice(slice) {
            if (slice.slice_type === 'table_of_contents' || slice.slice_type === 'jump_link_button') {
                return this.document;
            }
        }
    }
};
</script>
